module.exports = vendor_80e8860431bf6b58af38;